import script from "./OperadorFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./OperadorFrame.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/layoutFrames.css?vue&type=style&index=0&id=cab6ea4e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab6ea4e"]])

export default __exports__